const roleReducer = (state = false, action) => {
  switch (action.type) {
    case "LOGINADMIN":
      return true;
    case "LOGOUT":
      return false;
    default:
      return state;
  }
};

export default roleReducer;
